import { useState } from 'react'
import { useSelector, shallowEqual } from 'react-redux';
import { UserModel } from '../../../modules/auth/models/UserModel'
import PhoneInput from '../../ShippingLocationsPage/PhoneInput'
import { RootState } from '../../../../setup/redux/RootReducer';
import { CountryOptions } from '../../../data/CountryOptions';
import ZipcodesWithCountry from '../../LTLandVolumeTLPages/ZipcodesWithCountry';
import { FormsEditProps } from '../../../pages/vendors/models';
import { InputStyled } from '../../Inputs.styled';
import { formatPhone } from '../../../helpers/formatPhone';

const PDFHeaderBranding = ({formik}: FormsEditProps) => {
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const [zipcode, setZipcode] = useState('')
    const [city, setCity] = useState({
        City: formik.values.PDFHeaderBranding?.city,
        Country: CountryOptions.filter(country => country.CodePrimus === formik.values.PDFHeaderBranding?.country)[0]?.Code,
        Name: "",
        State: formik.values.PDFHeaderBranding?.state,
        Zipcode: formik.values.PDFHeaderBranding?.zipcode,
        isSL: false,
        isZipcode: true,
        id: null
    })
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number

    const setValuesBranding = (billToInformation) => {
        formik.setFieldValue('PDFHeaderBranding.name', billToInformation?.name || '')
        formik.setFieldValue('PDFHeaderBranding.address', billToInformation?.address || '')
        formik.setFieldValue('PDFHeaderBranding.address1', billToInformation?.address1 || '')
        formik.setFieldValue('PDFHeaderBranding.city', billToInformation?.city || '')
        formik.setFieldValue('PDFHeaderBranding.state', billToInformation?.state || '')
        formik.setFieldValue('PDFHeaderBranding.zipcode', billToInformation?.zipcode || '')
        formik.setFieldValue('PDFHeaderBranding.country', billToInformation?.country || 'US')
        formik.setFieldValue('PDFHeaderBranding.phone', formatPhone(billToInformation?.phone, (billToInformation?.country || 'US')) || '')
        formik.setFieldValue('PDFHeaderBranding.fax', billToInformation?.fax || '')

        setCity({
            City: billToInformation?.city || '',
            Country: CountryOptions.filter(country => country?.CodePrimus === billToInformation?.country)[0]?.Code || 'US',
            Name: '',
            State: billToInformation?.state || '',
            Zipcode: billToInformation?.zipcode || '',
            isSL: false,
            isZipcode: true,
            id: null
        })

        if(!billToInformation?.zipcode){
            setZipcode('')
        }
    }

    return (
        <>
            <div className="row align-items-center">
                <div className="col-12 col-sm-2 col-md-1">
                    <label className='form-label'>Name</label>
                </div>
                <div className="col-12 col-sm-10 col-md-5 mb-5 mb-md-0">
                    <InputStyled
                        type="text"
                        className="form-control"
                        autoComplete='off'
                        {...formik.getFieldProps('PDFHeaderBranding.name')}
                        fontSize={fontSize}
                        disabled={formik.values.PDFHeaderBranding?.PDFBranding === 'carrier' || formik.values.PDFHeaderBranding?.PDFBranding === 'none'}
                    />
                </div>
                <div className="col-12 col-sm-2 col-md-1">
                    <label className='form-label'>Address</label>
                </div>
                <div className="col-7 col-sm-6 col-md-3 mb-5 mb-md-0">
                    <InputStyled
                        type="text"
                        className="form-control"
                        autoComplete='new-password'
                        {...formik.getFieldProps('PDFHeaderBranding.address')}
                        fontSize={fontSize}
                        disabled={formik.values.PDFHeaderBranding?.PDFBranding === 'carrier' || formik.values.PDFHeaderBranding?.PDFBranding === 'none'}
                    />
                </div>
                <div className="col-5 col-sm-4 col-md-2 mb-5 mb-md-0">
                    <InputStyled
                        type="text"
                        className="form-control"
                        autoComplete='new-password'
                        {...formik.getFieldProps('PDFHeaderBranding.address1')}
                        fontSize={fontSize}
                        disabled={formik.values.PDFHeaderBranding?.PDFBranding === 'carrier' || formik.values.PDFHeaderBranding?.PDFBranding === 'none'}
                    />
                </div>
            </div>

            <div className="row align-items-center mt-0 mt-md-5">
                <div className="col-12 col-sm-2 col-md-1">
                    <label className='form-label'>C&#8204;ity</label>
                </div>
                <div className="col-12 col-sm-10 col-md-5 mb-5 mb-md-0">
                    <ZipcodesWithCountry
                        zipcodeLocal={zipcode}
                        setZipcodeLocal={setZipcode}
                        setDataFormik={formik?.setFieldValue}
                        setFieldError={formik?.setFieldError}
                        data={city}
                        setData={setCity}
                        countryOptions={CountryOptions}
                        userData={user}
                        error={''}
                        touched={{}}
                        setFieldTouched={() => {}}
                        editVendor
                        valueName='PDFHeaderBranding'
                        disabled={formik.values.PDFHeaderBranding?.PDFBranding === 'carrier' || formik.values.PDFHeaderBranding?.PDFBranding === 'none'}
                    />
                </div>
                <div className="col-12 col-sm-2 col-md-1">
                    <label className='form-label'>Phone</label>
                </div>
                <div className="col-12 col-sm-10 col-md-5">
                    <PhoneInput
                        value={formik.values.PDFHeaderBranding?.phone}
                        setDataFormik={formik.setFieldValue}
                        name='PDFHeaderBranding.phone'
                        countryCode={formik.values.PDFHeaderBranding?.country}
                        deleteSelectCountry={false}
                        disabled={formik.values.PDFHeaderBranding?.PDFBranding === 'carrier' || formik.values.PDFHeaderBranding?.PDFBranding === 'none'}
                    />
                </div>
            </div>

            <div className="row align-items-center mt-5">
                <div className="row">
                    <div className="col-sm-2 col-md-1">
                        <label className='form-label'>PDF Branding</label>
                    </div>
                    <div className="col-sm-7 col-lg-9 d-flex align-items-center">
                        <div className="form-check form-check-custom form-check-solid me-2">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="radioInquiry"
                                id='company'
                                value='company'
                                onChange={(e) => {
                                    formik.setFieldValue('PDFHeaderBranding.PDFBranding', e.target.value)
                                    setValuesBranding(user?.billToInformation)
                                }}
                                checked={formik.values.PDFHeaderBranding?.PDFBranding === 'company'}
                            />
                            <label className="form-check-label" htmlFor='company'>
                                Company
                            </label>
                        </div>
                        <div className="form-check form-check-custom form-check-solid me-2">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="radioInquiry"
                                id='carrier'
                                value='carrier'
                                onChange={(e) => {
                                    formik.setFieldValue('PDFHeaderBranding.PDFBranding', e.target.value)
                                    setValuesBranding({})
                                }}
                                checked={formik.values.PDFHeaderBranding?.PDFBranding === 'carrier'}
                            />
                            <label className="form-check-label" htmlFor='carrier'>
                                Carrier
                            </label>
                        </div>
                        <div className="form-check form-check-custom form-check-solid me-4">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="radioInquiry"
                                id='none'
                                value='none'
                                onChange={(e) => {
                                    formik.setFieldValue('PDFHeaderBranding.PDFBranding', e.target.value)
                                    setValuesBranding({})
                                }}
                                checked={formik.values.PDFHeaderBranding?.PDFBranding === 'none'}
                            />
                            <label className="form-check-label" htmlFor='none'>
                                None
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PDFHeaderBranding